import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MonitoringService } from '../_services/monitoring/monitoring.service';
import { describeError, isBenignError } from './describe-error';

/**
 * Replaces Angular's default ErrorHandler to forward unhandled errors to
 * Application Insights. Uses Injector (rather than direct constructor injection)
 * because ErrorHandler is instantiated before the full DI tree is available —
 * direct injection of MonitoringService here causes a circular dependency error.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    const asError = error instanceof Error ? error : new Error(describeError(error));
    if (!isBenignError(asError.message)) {
      this.injector.get(MonitoringService, null)?.trackException(asError);
    }
    console.error(error);
  }
}
